import { logger } from './logger';

/**
 * Function used to override the browsers user agent. By default this property
 * is read-only so we need to redefine the getter in order to override it.
 *
 * @param userAgent
 */
const overrideUserAgent = (userAgent: string) => {
  if (navigator) {
    logger.info('overriding user agent to:', {
      originalUserAgent: navigator.userAgent,
      newUserAgent: userAgent,
    });

    Object.defineProperty(navigator, 'userAgent', {
      get: function () {
        return userAgent;
      },
      configurable: true,
    });
  } else {
    logger.warn('unable to override user agent. navigator is not available');
  }
};

export { overrideUserAgent };
